import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { InitStoreEffects } from '@core-lib/store/init-store/effects';
import { InitStoreReducer } from '@core-lib/store/init-store/reducer';
import { FeatureName } from '@core-lib/store/init-store/feature';

@NgModule({
	imports: [CommonModule, StoreModule.forFeature(FeatureName, InitStoreReducer), EffectsModule.forFeature([InitStoreEffects])]
})
export class InitStoreModule {}
